<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section_hd"><a id="rec"></a><a id="ch1"></a><a id="page_17"></a><span class="green">No. 1</span></h1>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<h1><span class="green">Bloody Mary</span></h1>
<p class="pull_quote"><a id="page_18"></a>This spicy, zesty brunch drink opens the door to a wide range of savory sippers—and no, they don’t all contain tomato juice. The most obvious variations experiment with different spirits in place of classic vodka: tequila transforms Mary to Maria, for example. Or switch out the tomato juice component for carrot juice to create the not-so-classic Bloody Bunny.</p>
<p class="pull_quote">Or skip the juice altogether and veer toward other piquant, not-too-sweet cocktails, such as the beer-based Michelada, the savory Dirty Martini, or even the Coronation, which uses the salinity of dry sherry to mouthwatering effect.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07chapter01.vue?e68eb0ac